












































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { configuration as config } from "@/config/host.config";
import { IAlertState } from "@/@types/speciaMessage/speciaMessage";
import { AxiosError } from "axios";
import { deleteElement } from "@/api/delite/delite-element";

import MessageAlertForm from "@/components/forms/tv_admin/tv-mails/message-alert-form.vue";
import ButtonCart from "@/components/buttons/button-cart.vue";
import ButtonHistory from "@/components/buttons/button-history.vue";
import ButtonBack from "@/components/buttons/button-back.vue";
import MessageAlertList from "@/components/forms/tv_admin/tv-mails/message-alert-list.vue";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({
  components: {
    StandartModal,
    MessageAlertForm,
    ButtonCart,
    ButtonHistory,
    ButtonBack,
    MessageAlertList,
  },
})
class HelloConfig extends Vue {
  @Prop({ type: String, default: "" }) background!: string;
  helloBackgroundFolder = "main/configuration/background";
  helloLogoFolder = "main/configuration/logo";

  enabled = true;
  dragging = false;
  helloList: Array<IAlertState> = [];
  deletedToggle = false;

  $refs!: { "message-alert-form": MessageAlertForm };
  main_id = "";

  get mail(): IAlertState | null {
    const main = this.helloList.find((m) => m._id === this.main_id);
    return main ? main : null;
  }

  mustChange(id: string): void {
    this.main_id = id;
    this.$nextTick(() => this.$bvModal.show("message-alert-form"));
  }

  hide(): void {
    this.$refs["message-alert-form"].onReset();
    this.main_id = "";
    this.$emit("hide");
  }

  async sendHello(id: string, alert: Partial<IAlertState>): Promise<void> {
    const uri = id ? `${config.hello.main}/${id}` : config.hello.main;
    const method = id ? "put" : "post";
    alert.show = true;
    try {
      const res = await this.$axios[method](uri, alert);
      if (res.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        this.$bvModal.hide("message-alert-form");
        await this.getHello();
      }
    } catch (error: AxiosError | unknown) {
      console.log(error);
      this.onError(error as AxiosError, method);
    }
  }

  async restore(id: string): Promise<void> {
    if (!this.deletedToggle) return;
    const uri = config.hello.restore + "/" + id;
    try {
      const res = await this.$axios.put(uri);
      if (res.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        this.mustDeleted(id);
      }
    } catch (error: AxiosError | unknown) {
      console.log(error);
      this.onError(error as AxiosError, "put");
    }
  }

  async mustDeleted(id: string): Promise<void> {
    const i = this.helloList.findIndex((el) => el._id == id);
    if (i < 0) return this.getHello();
    this.helloList.splice(i, 1);
  }

  async deleted(id: string): Promise<void> {
    const uri = !this.deletedToggle ? config.hello.main : config.hello.force;
    deleteElement(id, uri)
      .then(() => {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        this.mustDeleted(id);
      })
      .catch((e: AxiosError) => {
        this.onError(e, "delete");
      });
  }

  @Watch("deletedToggle")
  async getHello(): Promise<void> {
    const params = { "match[deleted][value]": this.deletedToggle };
    try {
      const res = await this.$axios.get(config.hello.main, { params });
      if (res.status === 200) {
        this.helloList = res.data;
      }
    } catch (error) {
      console.log(error);
    }
  }

  onError(error: AxiosError, resp: string): void {
    console.error(error.message);
    this.$notify({
      group: "global",
      text: String(this.$i18n.t(`notify.${resp}.${error ? error.code : 0}`)),
      type: error && error.code === "200" ? "" : "warn",
    });
  }

  mounted(): void {
    this.getHello();
  }
}
export default HelloConfig;
